import type { IDomainPayloadType } from '@sfly/aurora-shared-react-components';

export const addEnvToDomainPayload = (
  domainPayload: IDomainPayloadType,
): IDomainPayloadType => {
  const rawEnv = process.env.VITE_APP_ENVIRONMENT;
  const env = (rawEnv === 'localhost' ? 'dev' : rawEnv) || 'prod';

  if (!domainPayload.reservedProps) {
    domainPayload.reservedProps = {};
  }

  domainPayload.reservedProps.env = env;

  return domainPayload;
};
